var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.modalShown)?_c('div',{staticClass:"modal-bg",class:{'modal-open': _vm.modalShown, 'modal-center': _vm.modalCenter}},[_c('div',{staticClass:"modal-container",class:_vm.modalClasses,attrs:{"role":"dialog"}},[_c('div',{staticClass:"modal-content"},[_vm._t("default")],2)])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }